export default {
      id: "icon-staractive-usage",
      viewBox: "0 0 12.67 11.7",
      url: __webpack_public_path__ + "icons.svg#icon-staractive",
      toString: function () {
        return this.url;
      }
    }